import { render, staticRenderFns } from "./ThanksPage.vue?vue&type=template&id=065d43ce&scoped=true&"
import script from "./ThanksPage.vue?vue&type=script&lang=js&"
export * from "./ThanksPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "065d43ce",
  null
  
)

export default component.exports